import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Location, NgIf, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { inject, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { ICurrency } from '@models/currency.model';
import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { EventsService } from '@services/events/events.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { VwoService } from '@services/vwo/vwo.service';
import { IFundraiser } from '@models/fundraiser.model';
import { DonationConfirmationComponent } from '@common-components/donation-confirmation/donation-confirmation.component';
import { DonationConfirmationSheetComponent } from '@common-components/donation-confirmation-sheet/donation-confirmation-sheet.component';
import { ExitIntentComponent } from '@common-components/donation-confirmation/components/exit-intent-component/exit-intent-component.component';
import { CustomTranslatePipe } from '@pipes/translate/translate.pipe';
import { CurrencyIconPipe } from '@pipes/currency-icon/currency-icon.pipe';
import { CurrencyDropdownComponent } from '../../../currency-dropdown/currency-dropdown.component';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';

@Component({
  selector: 'app-payment-header',
  templateUrl: './payment-header.component.html',
  styleUrls: ['./payment-header.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgTemplateOutlet,
    AsyncPipe,
    MatButtonModule,
    MatIconModule,
    ExitIntentComponent,
    CustomTranslatePipe,
    CurrencyIconPipe,
    CurrencyDropdownComponent,
    ComponentLoader
  ]
})
export class PaymentHeaderComponent {

  private paymentUtil = inject(PaymentUtilService);
  public util = inject(UtilService);
  public location = inject(Location);
  private actRoute = inject(ActivatedRoute);
  public dialog = inject(MatDialog);
  public router = inject(Router);
  public vars = inject(VariablesService);
  private bottomSheet = inject(MatBottomSheet);
  public vwo = inject(VwoService);
  public events = inject(EventsService);
  @ViewChild('exitIntentModal') exitIntentModal!: ExitIntentComponent;
  @Input() public fundraiser: IFundraiser;
  @Input() isReward;
  @Input() selectedCurrency;
  @Input() screenName;
  @Input() showBeneficiary;
  @Input() contributeDetails;
  @Input() isStandAlone;
  @Input() type = 'v1';
  @Input() tiptyp;
  @Output() userSelectionCurrency: EventEmitter<ICurrency> = new EventEmitter();
  supportedCurrencies: ICurrency[];
  currency;
  params;
  currentUrl;
  isMobile = this.vars.isMobile;

  ngOnInit() {
    
    if (this.vars.showKCart) {
      this.vwo.exit_intent_AB = () => '';
    }
    this.getCurrencyDetails();
    this.actRoute.queryParams.subscribe((params) => {
      this.params = params;
    });
  }

  //handle help with minimum amount
  handleHelpWithMininumAmount() {
    if ( this.vars.pageName === 'mini_story' && this.dialog) {
      this.dialog.closeAll();
    } else if (this.vars.pageName === 'stories' || this.vars.pageName === 'mini_story' && this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
    const ePayload = {
      eventName: 'donation_confirmation',
      page_name: this.vars.pageName || 'home',
      event_type_id: this.fundraiser.id,
      info_1: 'help_popup',
      info_2: this.contributeDetails?.min_donation
    };
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);
  }

  //handle maybe later 
  handleMaybeLater() {
    const ePayload = {
      eventName: 'donation_confirmation',
      page_name: this.vars.pageName || 'home',
      event_type_id: this.fundraiser.id,
      info_1: 'cancel_popup',
      info_2: this.contributeDetails?.min_donation
    };
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);
  }

  /**Get the details of the currency */
  getCurrencyDetails() {
    this.paymentUtil.supportedCurrencies.subscribe({
      next: (res) => {
        if (res) {
          setTimeout(() => {
            this.supportedCurrencies = res;
          }, 0);
        }
      }
    });
    this.paymentUtil.paymentCurrency.subscribe({ next: (res) => {
      this.currency = res;
    }});
  }
  /**Get the title */
  getTitle(param, op) {
    if (op && this.vars.isMobile) {
      // if (!this.vwoService.paymentV2AB) {
      switch (op) {
        case 'c': return this.vars.isMobile ? '' : 'Enter your card details';
        case 'p': return 'Payment using PayTM';
      }
      // } else {
      //   switch (op) {
      //     case 'CARD': return 'Cards';
      //     case 'UPI': return 'UPI';
      //     case 'NB': return 'Net Banking';
      //     case 'WALLET': return 'Wallets';
      //   }
      // }
    } else {
      switch (param) {
        case 'rd':
          return 'Choose Reward amount';
        case 'form':
          return 'Choose a contribution amount';
        case 'options':
          return 'Choose payment option';
      }
    }
  }
  /**Get emited currency fromheader and set it */
  setCurrency(currency: ICurrency) {
    this.paymentUtil.paymentCurrency.next(currency.currency);
    this.userSelectionCurrency.emit(currency);
  }
  /**Back action of payment header */
  back() {
    const params = { ...this.actRoute.snapshot.queryParams };
    if (params?.st === 'f' && params?.frtip && this.vars.pageName === 'thank_you') {
      this.dialog.closeAll();
      return
    }
    if (this.isMobile && this.vars.pageName.match('mini_story') && params?.payment === 'options') {
      this.vars.paymentFormAction.next('closed');
      this.dialog.closeAll();
      this.router.navigate([], { queryParams: { st: null, payment: 'form', op: null }, queryParamsHandling: 'merge' });
      return;
    }
    if (params?.st === 'f' && params?.payment === 'options' && this.vars.showKCart && ((!this.vars.isMobile && this.vars.pageName.match('stories|mini_story')) || (this.vars.isMobile && !this.vars.pageName.match('stories|mini_story')))) {
      this.router.navigate([], { queryParams: { payment: 'form' }, queryParamsHandling: 'merge' });
      this.screenName = 'form';
      return
    } else if (params?.st === 'f' && params?.payment === 'options') {
      this.router.navigate([], { queryParams: { payment: 'form', op: null }, queryParamsHandling: 'merge' });
      this.screenName = 'form';
      return
    } else if (params?.st === 'f' && params?.payment === 'options' && this.vars.isMobile && (this.vars.pageName.match('stories|mini_story') || this.vars.showStoryOnFundraiser)) {
      this.router.navigate([], { queryParams: { payment: 'form' }, queryParamsHandling: 'merge' });
      this.screenName = 'form';
      return;
    }

    if (this.screenName === this.params.payment && !this.params.op && !this.isStandAlone) {
      if (!this.tiptyp && (this.vwo.exit_intent_AB() === 'exit_intent' || this.vwo.exit_intent_AB() === 'exit_intent_trust')){
        this.exitIntentModal.open();
      } else if (!this.vars.isMobile && !this.tiptyp ) {
        const dialogRef = this.dialog.open(DonationConfirmationComponent, {
          data: { contributeDetails: this.contributeDetails, currency: this.currency },
          width: '100%',
          height: 'auto',
          maxWidth: '500px',
          maxHeight: '536px',
          panelClass: 'confirmation-modal'
        });
        dialogRef.componentInstance.cancelPayment.subscribe(() => {
          this.vars.paymentFormAction.next('closed');
          if (this.isStandAlone) {
            this.location.back();
          } else if (!this.vars.pageName.match('stories|mini_story')) {
            this.router.navigate([], { queryParams: { st: null }, queryParamsHandling: 'merge' });
          }
        });
      } else if (this.vars.isMobile && !this.tiptyp) {
        const bottomSheetRef = this.bottomSheet.open(DonationConfirmationSheetComponent, {
          data: { contributeDetails: this.contributeDetails, currency: this.currency },
          panelClass: 'confirmation-modal-sheet'
        });
        bottomSheetRef.afterDismissed().subscribe((val) => {
          this.vars.paymentFormAction.next('closed');
          if (this.isStandAlone) {
            this.location.back();
          } else if (!this.vars.pageName.match('stories|mini_story')) {
            this.router.navigate([], { queryParams: { st: null }, queryParamsHandling: 'merge' });
          } else if (this.vars.pageName.match('mini_story')) {
            this.location.back();
          }
        });
      } else {
        this.dialog.closeAll();
        if (this.isStandAlone) {
          this.location.back();
        }
      }
      const payload = {
        eventName: 'exitIntent_back',
        event_type_id: this.fundraiser.id
      }
      this.events.sendSystemEvent(payload).subscribe(_ => _);
    } else if (this.params?.st === 'f' && this.params?.payment === 'options' && !this.params?.op && this.isStandAlone) {
      this.router.navigate([], { queryParams: { payment: 'form' }, queryParamsHandling: 'merge' });
    } else {
      this.location.back();
      this.paymentUtil.backButton.next(this.params);
      this.paymentUtil.cartSubs.forEach(s => s.unsubscribe());
    }
  }

}
